export default (errors, message) => errors?.data?.errors?.some((err) => err?.errorMessage?.includes(message));
